var Handlebars = require("../../../../../../../../../../../../../tools/jenkins.plugins.nodejs.tools.NodeJSInstallation/NodeJS_18.16.0/lib/node_modules/@core/macys-cli/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "gr";
},"3":function(container,depth0,helpers,partials,data) {
    return "red";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.noNotifications : depth0),{"name":"unless","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"6":function(container,depth0,helpers,partials,data) {
    var helper;

  return "      <span class=\"num\">"
    + container.escapeExpression(((helper = (helper = helpers.notificationCount || (depth0 != null ? depth0.notificationCount : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"notificationCount","hash":{},"data":data}) : helper)))
    + "</span>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div id='notifications-icon' class='icon-gen-email-"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.noNotifications : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "-huge email-icon'>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showIndicator : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>";
},"useData":true});